import React, { createContext, useContext, useEffect, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const VipLimitContext = createContext();

export const useVipLimit = () => {
  const context = useContext(VipLimitContext);
  if (!context) {
    throw new Error('useVipLimit must be used within a VipLimitProvider');
  }
  return context;
};

export const VipLimitProvider = ({ children }) => {
  const navigate = useNavigate();
  // 使用 ref 存储最新的 navigate，避免 stale closure
  const navigateRef = useRef(navigate);
  navigateRef.current = navigate;

  // 监听全局 vip-limit-reached 事件（由 api.js 拦截器触发）
  useEffect(() => {
    const handler = (e) => {
      const { action, message, limit, used } = e.detail || {};
      navigateRef.current('/vip-limit', {
        state: { action, message, limit, used },
        replace: true,
      });
    };
    window.addEventListener('vip-limit-reached', handler);
    return () => window.removeEventListener('vip-limit-reached', handler);
  }, []);

  // 主动触发限额页面（用于前端预检查场景）
  const showLimitPage = useCallback((info) => {
    navigateRef.current('/vip-limit', {
      state: info,
      replace: true,
    });
  }, []);

  return (
    <VipLimitContext.Provider value={{ showLimitPage }}>
      {children}
    </VipLimitContext.Provider>
  );
};
